module.exports = __webpack_public_path__ + "static/media/consultation3.e956b007.avif";